import Model from './Model';
import * as _ from 'lodash';
import {knob} from './Configuration';
class Address extends Model {
  private company: String = '';
  private first_name: String = '';
  private last_name: String = '';
  private address_1: String = '';
  private address_2: String = '';
  private city: String = '';
  private state: String = '';
  private country: String = '';
  private zipcode: String = '';
  private phone: String = '';
  private phone_code: String = '';
  private phone_arr: any = {
    code: '',
    value: ''
  };
  constructor(options) {
    super();
    options.phone_arr = {
      code: options.phone_code,
      value: options.phone
    };
    this.bind(options);
  }
}

export default Address;
